import { WHY, IMG } from "../../data/content";
import { Chapter, Reveal, Btn } from "../shared";

export default function WhyBigWedd() {
  return (
    <section className="relative overflow-hidden bg-emerald-deep py-24 md:py-32" data-testid="why-big-wedd">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 md:grid-cols-2 md:px-12">
        <div className="relative order-2 md:order-1">
          <Reveal>
            <div className="gold-frame overflow-hidden">
              <img src={IMG.whyBigWedd} alt="Palace wedding venue" loading="lazy" className="h-[420px] md:h-[620px] w-full object-cover" />
            </div>
          </Reveal>
          <div className="pointer-events-none absolute -bottom-6 -right-6 hidden h-40 w-40 border-b border-r border-gold/50 md:block" />
        </div>
        <div className="order-1 md:order-2">
          <Chapter num="08" title="Why The Big Wedd" dark />
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl leading-[1.05] text-ivory">
              One team. One vision.<br /><span className="italic text-gold-light">Complete execution.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-lg text-sm md:text-base leading-relaxed text-ivory/60">
              We do not simply organise weddings — we create complete experiences. Planning, design, hospitality and production, held together by one responsible team.
            </p>
          </Reveal>
          <ul className="mt-10 grid grid-cols-1 gap-x-8 sm:grid-cols-2">
            {WHY.map((w, i) => (
              <Reveal key={w} delay={0.05 * i}>
                <li className="flex items-center gap-3 border-b border-gold/15 py-3.5 text-sm text-ivory/85" data-testid={`why-item-${i}`}>
                  <span className="h-1.5 w-1.5 rotate-45 bg-gold" /> {w}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.3}>
            <div className="mt-10">
              <Btn to="/contact" testid="why-cta">Plan My Wedding</Btn>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
